'use strict';

angular.module('mobile-apps')
	.service('TranslationOrderConstants', [function() {

		return {
			status: {
				draft: {
					name: 'Draft',
					class: 'label-info'
				},
				requested: {
					name: 'Quote Requested',
					class: 'label-primary'
				},
				created: {
					name: 'Quote Created',
					class: 'label-primary'
				},
				declined: {
					name: 'Quote Declined',
					class: 'label-danger'
				},
				accepted: {
					name: 'Quote Accepted',
					class: 'label-warning'
				},
				processing: {
					name: 'Processing',
					class: 'label-warning'
				},
				done: {
					name: 'Done',
					class: 'label-success'
				},
                canceled: {
				    name: 'Canceled',
                    class: 'label-danger'
                }

			},
			selectStringOptions: {
				all: {
					name: 'All',
					description: 'All IDs, current Drafts will be overwritten'
				},
				untranslated: {
					name: 'All untranslated',
					description: 'All IDs without Draft and without Target value'
				},
				withoutTarget: {
					name: 'All without target',
					description: 'All IDs which have no Target values, current Drafts will be overwritten'
				},
				sourceChanged: {
					name: 'All outdated translations',
					description: 'All IDs with outdated Target values, current Drafts will be overwritten'
				},
				invalidTarget: {
					name: 'All untranslated or outdated translations',
					description: 'All IDs without Draft and without Target values, or with outdated Target values. Current Drafts will be overwritten.'
				},
                needsTranslation: {
				    name: 'All with Needs Translation',
                    description: 'All IDs with "Needs Translation" status'
                },
                needsReview: {
                    name: 'All with Needs Review',
                    description: 'All IDs with "Needs Review" status'
                },
                rejected: {
				    name: 'All with Rejected',
                    description: 'All IDs with "Rejected" status'
                },
                needsTranslationOrRejected: {
                    name: 'All with Needs Translation or Rejected',
                    description: 'All IDs with "Needs Translation" or "Rejected" status'
                }
			}
		};
	}
	]);

